import { styled } from '@mui/material/styles';
import theme from '../../theme';

export const FullImage = styled('img')({
  width: '100%',
  maxWidth: '360px'
})

export const ArrowRightUpIn = styled('span')({
  zIndex: 800,
  position: 'absolute',
  top: '-13px',
  right: '30px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: 'transparent transparent white transparent',
})

export const ArrowRightUpOut = styled('span')({
  zIndex: 500,
  position: 'absolute',
  top: '-14px',
  right: '30px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: `transparent transparent ${theme.palette.grey.w100} transparent`,
})

export const ArrowUpIn = styled('span')({
  zIndex: 800,
  position: 'absolute',
  top: '-24px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: 'transparent transparent white transparent',
})

export const ArrowUpOut = styled('span')({
  zIndex: 500,
  position: 'absolute',
  top: '-25px',
  borderWidth: '14px',
  borderStyle: 'solid',
  borderColor: `transparent transparent ${theme.palette.grey.w100} transparent`,
})